import { ColorCodes } from '../../../foundations/color';
import { genThemedStyled } from '../../../utilities/theme';
import { MEDIA_QUERIES as M } from '../../../foundations/grid';
import S from '../../../foundations/size';

type themeStyles = {
  backgroundColor: ColorCodes;
  headerTitleColor: ColorCodes;
  textTitleColor: ColorCodes;
  subTextColor: ColorCodes;
  dividerColor: ColorCodes;
  iconColor: ColorCodes;
  descriptionTitleColor: ColorCodes;
  linkTextColor: ColorCodes;
  activeBackgroundColor: ColorCodes;
  borderColor: ColorCodes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

export const FormContainer = ThemeStyled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: S.M,
});

export const InputWrapper = ThemeStyled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: S.XXS,
  width: '100%',
});

export const RightContainer = ThemeStyled.div<{
  hasChanges?: boolean;
  action?: string;
  isStickyFooter?: boolean;
}>(({ hasChanges, action, isStickyFooter = false }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: S.L,
  paddingLeft: isStickyFooter ? '3.75rem' : 0,
  marginBottom: hasChanges && isStickyFooter ? '8.5rem' : 'unset',
  [M.TABLET_LANDSCAPE_AND_SMALLER]: {
    flexDirection: action === 'none' ? 'column-reverse' : 'column',
    paddingLeft: 'unset',
  },
}));

export const TwoColumnInputWrapper = ThemeStyled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  columnGap: S.M,
});

export const StickyFooter = ThemeStyled.div<{
  hasChanges: boolean;
  theme: themeStyles;
}>(({ hasChanges, theme }) => ({
  maxWidth: '90rem',
  paddingRight: '8.5rem',
  backgroundColor: theme.backgroundColor,
  width: '66%',
  position: 'fixed',
  bottom: hasChanges ? 0 : `-8rem`,
  [M.TABLET_LANDSCAPE_AND_SMALLER]: {
    paddingRight: '8.5rem',
    width: '100%',
  },
  [M.MOBILE_ONLY]: {
    bottom: hasChanges ? 0 : `-12rem`,
    paddingRight: '1.75rem',
  },
  transitionProperty: 'bottom',
  transitionDuration: '0.5s',
}));

export const FooterButtonWrappers = ThemeStyled.div({
  width: '12.5rem',
  [M.MOBILE_ONLY]: {
    width: 'unset',
  },
});

export const FooterContent = ThemeStyled.div(p => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  gap: S.M,
  paddingBottom: S.XXXL,
  paddingTop: S.XL,
  maxWidth: '51rem',
  borderTop: `1px solid ${p.theme.dividerColor}`,
  [M.SMALL_DESKTOP_AND_SMALLER]: {
    maxWidth: 'unset',
  },
  [M.MOBILE_ONLY]: {
    flexDirection: 'column',
  },
}));

export const Footer = ThemeStyled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: S.L,
  paddingTop: S.L,
  [M.MOBILE_ONLY]: {
    flexDirection: 'row',
    paddingTop: S.M,
  },
});
